/**
 * Alphabetically sorts the provided accounts and separates them into admin-use
 * and customer groups. Accounts with `adminUseOnly` set to true are placed in
 * the admin list; all others are put in the customer list.
 *
 * @param {Array<{id: string, name: string, adminUseOnly?: boolean}>} accounts
 * @returns {{adminUseAccounts: Array<object>, customerAccounts: Array<object>}}
 */
export function sortAndGroupAccounts(accounts = []) {
    const sorted = [...accounts].sort((a, b) => {
        const nameA = (a.name || "").toLowerCase();
        const nameB = (b.name || "").toLowerCase();
        return nameA.localeCompare(nameB);
    });

    const adminUseAccounts = [];
    const customerAccounts = [];
    sorted.forEach((acc) => {
        if (acc.adminUseOnly) {
            adminUseAccounts.push(acc);
        } else {
            customerAccounts.push(acc);
        }
    });
    return { adminUseAccounts, customerAccounts };
}
